// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CftcDashboardLayout_container__sXnm- {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  color: var(--color-text);
  font-size: var(--font-size-body);
  line-height: 1.5;
}

.CftcDashboardLayout_stack__69nFo {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.CftcDashboardLayout_section__ImfPs {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.CftcDashboardLayout_sectionHeader__5z7El {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.CftcDashboardLayout_sectionHeaderLeft__gpe26 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.CftcDashboardLayout_sectionTitle__W\\+ieX {
  font-size: var(--font-size-title);
  font-weight: 600;
  color: var(--color-text-strong);
}

.CftcDashboardLayout_pillsRow__fcu0X {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.CftcDashboardLayout_metaText__i\\+VyN {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.CftcDashboardLayout_sectionGuideRow__qbIq7 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.CftcDashboardLayout_sectionBody__sXQLq {
  margin-top: 8px;
}

.CftcDashboardLayout_grid__u9XOq {
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr;
}

.CftcDashboardLayout_gridCol4__Um3IE {
  grid-column: span 1;
}

.CftcDashboardLayout_gridCol8__hN2s7 {
  grid-column: span 1;
}

.CftcDashboardLayout_chartCard__Zc4yz {
  border: 1px solid var(--color-border);
  border-radius: 16px;
  background: var(--color-bg-panel);
  padding: 16px;
}

.CftcDashboardLayout_chartHeader__MJ3lk {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.CftcDashboardLayout_chartHeaderMeta__GQjSF {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.CftcDashboardLayout_chartSummary__78K7V {
  margin-top: 8px;
  font-size: var(--font-size-body);
  font-weight: 700;
  color: var(--color-text);
  line-height: 1.4;
}

.CftcDashboardLayout_chartSummaryLabel__5Dl-V {
  font-weight: 700;
}

.CftcDashboardLayout_chartTitle__1ceRV {
  font-size: var(--font-size-title);
  font-weight: 600;
  color: var(--color-text-strong);
}

.CftcDashboardLayout_chartBody__03PdY {
  margin-top: 12px;
  min-height: 280px;
}

.CftcDashboardLayout_chartTitleRow__l6Ty7 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.CftcDashboardLayout_infoIcon__x0t49 {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  color: var(--color-text-muted);
  font-size: var(--font-size-tiny);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
}

.CftcDashboardLayout_infoIcon__x0t49:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-accent), 0 0 0 4px var(--color-bg);
}

.CftcDashboardLayout_infoTooltip__9y6rU {
  position: absolute;
  top: 0;
  left: 26px;
  width: 360px;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  color: var(--color-text);
  font-size: var(--font-size-caption);
  line-height: 1.4;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-4px);
  transition: opacity 120ms ease-out, transform 120ms ease-out;
  z-index: 100;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.CftcDashboardLayout_infoTitle__kBJeC {
  display: block;
  font-weight: 600;
  margin: 10px 0 6px;
  color: var(--color-text);
}

.CftcDashboardLayout_infoText__EU1SY {
  display: block;
  margin-bottom: 6px;
  color: var(--color-text-muted);
}

.CftcDashboardLayout_infoList__8QxZo {
  margin: 0;
  padding-left: 16px;
  color: var(--color-text-muted);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.CftcDashboardLayout_infoList__8QxZo ul {
  margin: 6px 0 0 14px;
  padding-left: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.CftcDashboardLayout_infoNote__cywIU {
  margin-top: 4px;
  color: var(--color-text-muted);
}

.CftcDashboardLayout_infoIcon__x0t49:hover .CftcDashboardLayout_infoTooltip__9y6rU,
.CftcDashboardLayout_infoIcon__x0t49:focus-visible .CftcDashboardLayout_infoTooltip__9y6rU {
  opacity: 1;
  transform: translateY(0);
}

@media (min-width: 1024px) {
  .CftcDashboardLayout_grid__u9XOq {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .CftcDashboardLayout_gridCol4__Um3IE {
    grid-column: span 4;
  }

  .CftcDashboardLayout_gridCol8__hN2s7 {
    grid-column: span 8;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/cftc/CftcDashboardLayout.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;EACnC,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,4DAA4D;EAC5D,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".container {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  color: var(--color-text);\n  font-size: var(--font-size-body);\n  line-height: 1.5;\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sectionHeader {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.sectionHeaderLeft {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sectionTitle {\n  font-size: var(--font-size-title);\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.pillsRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.metaText {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.sectionGuideRow {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 10px;\n}\n\n.sectionBody {\n  margin-top: 8px;\n}\n\n.grid {\n  display: grid;\n  gap: 24px;\n  grid-template-columns: 1fr;\n}\n\n.gridCol4 {\n  grid-column: span 1;\n}\n\n.gridCol8 {\n  grid-column: span 1;\n}\n\n.chartCard {\n  border: 1px solid var(--color-border);\n  border-radius: 16px;\n  background: var(--color-bg-panel);\n  padding: 16px;\n}\n\n.chartHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.chartHeaderMeta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.chartSummary {\n  margin-top: 8px;\n  font-size: var(--font-size-body);\n  font-weight: 700;\n  color: var(--color-text);\n  line-height: 1.4;\n}\n\n.chartSummaryLabel {\n  font-weight: 700;\n}\n\n.chartTitle {\n  font-size: var(--font-size-title);\n  font-weight: 600;\n  color: var(--color-text-strong);\n}\n\n.chartBody {\n  margin-top: 12px;\n  min-height: 280px;\n}\n\n.chartTitleRow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.infoIcon {\n  position: relative;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  color: var(--color-text-muted);\n  font-size: var(--font-size-tiny);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n}\n\n.infoIcon:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--color-accent), 0 0 0 4px var(--color-bg);\n}\n\n.infoTooltip {\n  position: absolute;\n  top: 0;\n  left: 26px;\n  width: 360px;\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  color: var(--color-text);\n  font-size: var(--font-size-caption);\n  line-height: 1.4;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-4px);\n  transition: opacity 120ms ease-out, transform 120ms ease-out;\n  z-index: 100;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.infoTitle {\n  display: block;\n  font-weight: 600;\n  margin: 10px 0 6px;\n  color: var(--color-text);\n}\n\n.infoText {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--color-text-muted);\n}\n\n.infoList {\n  margin: 0;\n  padding-left: 16px;\n  color: var(--color-text-muted);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.infoList ul {\n  margin: 6px 0 0 14px;\n  padding-left: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.infoNote {\n  margin-top: 4px;\n  color: var(--color-text-muted);\n}\n\n.infoIcon:hover .infoTooltip,\n.infoIcon:focus-visible .infoTooltip {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n@media (min-width: 1024px) {\n  .grid {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n\n  .gridCol4 {\n    grid-column: span 4;\n  }\n\n  .gridCol8 {\n    grid-column: span 8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CftcDashboardLayout_container__sXnm-`,
	"stack": `CftcDashboardLayout_stack__69nFo`,
	"section": `CftcDashboardLayout_section__ImfPs`,
	"sectionHeader": `CftcDashboardLayout_sectionHeader__5z7El`,
	"sectionHeaderLeft": `CftcDashboardLayout_sectionHeaderLeft__gpe26`,
	"sectionTitle": `CftcDashboardLayout_sectionTitle__W+ieX`,
	"pillsRow": `CftcDashboardLayout_pillsRow__fcu0X`,
	"metaText": `CftcDashboardLayout_metaText__i+VyN`,
	"sectionGuideRow": `CftcDashboardLayout_sectionGuideRow__qbIq7`,
	"sectionBody": `CftcDashboardLayout_sectionBody__sXQLq`,
	"grid": `CftcDashboardLayout_grid__u9XOq`,
	"gridCol4": `CftcDashboardLayout_gridCol4__Um3IE`,
	"gridCol8": `CftcDashboardLayout_gridCol8__hN2s7`,
	"chartCard": `CftcDashboardLayout_chartCard__Zc4yz`,
	"chartHeader": `CftcDashboardLayout_chartHeader__MJ3lk`,
	"chartHeaderMeta": `CftcDashboardLayout_chartHeaderMeta__GQjSF`,
	"chartSummary": `CftcDashboardLayout_chartSummary__78K7V`,
	"chartSummaryLabel": `CftcDashboardLayout_chartSummaryLabel__5Dl-V`,
	"chartTitle": `CftcDashboardLayout_chartTitle__1ceRV`,
	"chartBody": `CftcDashboardLayout_chartBody__03PdY`,
	"chartTitleRow": `CftcDashboardLayout_chartTitleRow__l6Ty7`,
	"infoIcon": `CftcDashboardLayout_infoIcon__x0t49`,
	"infoTooltip": `CftcDashboardLayout_infoTooltip__9y6rU`,
	"infoTitle": `CftcDashboardLayout_infoTitle__kBJeC`,
	"infoText": `CftcDashboardLayout_infoText__EU1SY`,
	"infoList": `CftcDashboardLayout_infoList__8QxZo`,
	"infoNote": `CftcDashboardLayout_infoNote__cywIU`
};
export default ___CSS_LOADER_EXPORT___;
